import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { useState } from 'react';
import { push } from 'connected-react-router';
import ProfileForm from './components/ProfileForm';
import DefaultView from './components/DefaultView';
import EmailForm from './components/EmailForm';


/**
 * User
 */
const User = (props) => {
  const [currentView, setCurrentView] = useState('default');

  const _renderView = () => {
    switch (currentView) {
      case 'email-form':
        return (
          <EmailForm 
            setCurrentView={setCurrentView}
          />
        );
      case 'profile-form':
        return (
          <ProfileForm 
            setCurrentView={setCurrentView}
          />
        )
      default:
        return (
          <DefaultView setCurrentView={setCurrentView} />
        );
    }
  }

  return (
    <div style={{ background: 'white', borderRadius: 5, width: 320, margin: 'auto', padding: 10 }}>       
      {
        _renderView()
      }
    </div>
  )    
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui,
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(User));